import { pieTitleStyle } from './MiniPieChart.jsx';
import { sentimentScoreColor } from '../utils/sentiment.js';

/**
 * MiniScoreCircle — a compact circular stat matching MiniPieChart's footprint,
 * used for the CES average on the dashboard pie row. Shows the score as
 * "x / max" with the response count beneath, inside a solid colored circle.
 *
 * Props:
 *   title   {string}
 *   value   {number|null}  — the average score
 *   max     {number}       — denominator (default 5)
 *   n       {number}       — response count
 *   loading {boolean}
 */

const WIDTH = 180;
const HEIGHT = 160;

const boxStyle = {
  width: WIDTH,
  height: HEIGHT,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#999',
  fontSize: 12,
  background: '#f5f6f8',
  borderRadius: 6,
};

export default function MiniScoreCircle({ title, value, max = 5, n, loading }) {
  const hasValue = typeof value === 'number' && !Number.isNaN(value);
  const color = sentimentScoreColor(hasValue ? value : null);

  return (
    <div style={{ width: WIDTH }}>
      <p style={pieTitleStyle}>{title}</p>
      {loading ? (
        <div style={boxStyle}>Loading…</div>
      ) : !hasValue ? (
        <div style={boxStyle}>No data</div>
      ) : (
        <svg width={WIDTH} height={HEIGHT} role="img" aria-label={`${title}: ${value.toFixed(1)} of ${max}`}>
          <circle cx={90} cy={80} r={70} fill={color} />
          <text
            x={90}
            y={73}
            textAnchor="middle"
            dominantBaseline="central"
            fill="#fff"
            fontSize={28}
            fontWeight="bold"
          >
            {`${value.toFixed(1)} / ${max}`}
          </text>
          {typeof n === 'number' && (
            <text
              x={90}
              y={102}
              textAnchor="middle"
              dominantBaseline="central"
              fill="#fff"
              fontSize={11}
              opacity={0.85}
            >
              {`${n} response${n === 1 ? '' : 's'}`}
            </text>
          )}
        </svg>
      )}
    </div>
  );
}
